import React, { useMemo } from "react";
import { faker } from "@faker-js/faker";
import { DataGridPro, type GridColDef } from "@mui/x-data-grid-pro";

type UserData = {
  id: number;
  name: string;
  email: string;
};

export const generateFakeData = (numRows: number): UserData[] => {
  return Array.from({ length: numRows }, (_, index) => ({
    id: index + 1,
    name: faker.person.fullName(),
    email: faker.internet.email(),
  }));
};

const DataGridClient: React.FC = () => {
  const rows: UserData[] = useMemo(() => generateFakeData(1000000), []);

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "email", headerName: "Email", width: 250 },
  ];

  return (
    <DataGridPro
      rows={rows}
      columns={columns}
      pagination
      pageSizeOptions={[25, 50, 100]}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 25, page: 0 },
        },
      }}
    />
  );
};

export default DataGridClient;
